import { type GameId } from "../App";

// Language options from the original launcher.js
const SUPPORTED_LANGUAGES: [string, string][] = [
    ['be', "Беларуская [be]"],
    ['bg', "Български [bg]"],
    ['ca', "Català [ca]"],
    ['cs', "Česky [cs]"],
    ['cy', "Cymraeg [cy]"],
    ['da', "Dansk [da]"],
    ['de', "Deutsch [de]"],
    ['el', "Ελληνικά [el]"],
    ['en', "English [en]"],
    ['eo', "Esperanto [eo]"],
    ['es', "Español [es]"],
    ['et', "Eesti [et]"],
    ['eu', "Euskara [eu]"],
    ['fi', "Suomi [fi]"],
    ['fil', "Wikang Filipino [fil]"],
    ['fr', "Français [fr]"],
    ['gd', "Gàidhlig [gd]"],
    ['gl', "Galego [gl]"],
    ['hu', "Magyar [hu]"],
    ['id', "Bahasa Indonesia [id]"],
    ['it', "Italiano [it]"],
    ['ja', "日本語 [ja]"],
    ['jbo', "Lojban [jbo]"],
    ['kk', "Қазақша [kk]"],
    ['ko', "한국어 [ko]"],
    ['ky', "Kırgızca / Кыргызча [ky]"],
    ['lt', "Lietuvių [lt]"],
    ['lv', "Latviešu [lv]"],
    ['mn', "Монгол [mn]"],
    ['mr', "मराठी [mr]"],
    ['ms', "Bahasa Melayu [ms]"],
    ['nb', "Norsk Bokmål [nb]"],
    ['nl', "Nederlands [nl]"],
    ['nn', "Norsk Nynorsk [nn]"],
    ['oc', "Occitan [oc]"],
    ['pl', "Polski [pl]"],
    ['pt', "Português [pt]"],
    ['pt_BR', "Português do Brasil [pt_BR]"],
    ['ro', "Română [ro]"],
    ['ru', "Русский [ru]"],
    ['sk', "Slovenčina [sk]"],
    ['sl', "Slovenščina [sl]"],
    ['sr_Cyrl', "Српски [sr_Cyrl]"],
    ['sr_Latn', "Srpski (Latinica) [sr_Latn]"],
    ['sv', "Svenska [sv]"],
    ['sw', "Kiswahili [sw]"],
    ['tr', "Türkçe [tr]"],
    ['tt', "Tatarça [tt]"],
    ['uk', "Українська [uk]"],
    ['vi', "Tiếng Việt [vi]"],
    ['zh_CN', "中文 (简体) [zh_CN]"],
    ['zh_TW', "正體中文 (繁體) [zh_TW]"],
];

// Proxy options from the original index.html
const PROXIES: [string, string][] = [
    ["wss://na1.dustlabs.io/mtproxy", "North America"],
    ["wss://sa1.dustlabs.io/mtproxy", "South America"],
    ["wss://eu1.dustlabs.io/mtproxy", "Europe"],
    ["wss://ap1.dustlabs.io/mtproxy", "Asia"],
    ["wss://ap2.dustlabs.io/mtproxy", "Australia"],
    ["wss://minetest.ahmels.org", "Eike's Proxy"],
    ["wss://eu1.dustlabs.io/testproxy", "Paradust's test Proxy"],
];

const GAME_IDS: GameId[] = ['minetest_game', 'mineclonia', 'mineclone2', 'glitch', 'blockbomber'];

export { SUPPORTED_LANGUAGES, PROXIES, GAME_IDS };